import { replaceNorwegianChars, toKebabCase } from '@utils/text-utils';
import type { DataAttributeValues } from './types';

const baseDataAttributePrefix = 'sparing-create-child-account';

const formatDataTrackLinkname = (linkName: string): string => toKebabCase(replaceNorwegianChars(linkName));

// data-testid: For test tools
// data-track-id: For tracking purposes with PIWIK | sparing-create-child-account-${trackId}
// data-track-linkname: For tracking purposes with PIWIK: Should be the same name as button/link/etc label in kebab-case
const createDataAttributeValues = (testId: string, trackId: string, linkName: string): DataAttributeValues => ({
    'data-testid': testId,
    'data-track-id': `${baseDataAttributePrefix}-${trackId}`,
    'data-track-linkname': formatDataTrackLinkname(linkName),
});

export const getChildrenListDataAttrs = (testId: string, linkName: string) =>
    createDataAttributeValues(testId, 'children-list', linkName);

export const getDocumentConsentDataAttrs = (testId: string, linkName: string) =>
    createDataAttributeValues(testId, 'document-consent', linkName);

export const getEnterApproverParentInformationDataAttrs = (testId: string, linkName: string) =>
    createDataAttributeValues(testId, 'enter-approver-parent-information', linkName);
